import React, { useState, useEffect } from 'react';
import { useAuth, apiFetch } from '../App';
import { useNavigate } from 'react-router-dom';

export default function LeaguePage() {
  const { user, showToast, loadMe } = useAuth();
  const navigate = useNavigate();
  const [leagues, setLeagues]   = useState([]);
  const [tiers, setTiers]       = useState([]);
  const [myLeagues, setMyLeagues] = useState([]);
  const [board, setBoard]       = useState(null);
  const [paying, setPaying]     = useState({});
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    // Check if returned from league payment
    const params = new URLSearchParams(window.location.search);
    const status = params.get('status');
    if (status === 'successful') {
      showToast('Payment successful! ✅ League entry confirmed.', 'success');
      window.history.replaceState({}, '', '/league');
      setTimeout(() => loadMe(), 2000);
    }
  }, []);

  useEffect(() => {
    Promise.all([
      apiFetch('/api/web/league/active').then(setLeagues).catch(()=>{}),
      apiFetch('/api/web/league/tiers').then(setTiers).catch(()=>{}),
      user ? apiFetch('/api/web/league/me').then(setMyLeagues).catch(()=>{}) : Promise.resolve(),
    ]).finally(() => setLoading(false));
  }, [user]);

  async function buyPass(tier) {
    if (!user) { navigate('/auth'); return; }
    if (paying[tier]) return;
    setPaying(p => ({...p,[tier]:true}));
    try {
      const d = await apiFetch('/api/web/league/initiate', { method:'POST', body:{ tier }});
      if (d.paymentLink) window.location.href = d.paymentLink;
    } catch(err) { showToast(err.message, 'error'); }
    setPaying(p => ({...p,[tier]:false}));
  }

  async function viewBoard(leagueId, tier, week) {
    try {
      const b = await apiFetch(`/api/web/league/${leagueId}/leaderboard`);
      setBoard({ leagueId, tier, week, entries: b });
    } catch(err) { showToast(err.message, 'error'); }
  }

  if (loading) return <div style={{ textAlign:'center', padding:60, color:'var(--muted)' }}>Loading...</div>;

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:28, letterSpacing:1.5, marginBottom:4 }}>PREDICTION LEAGUE</div>
        <div style={{ fontSize:13, color:'var(--text2)' }}>Buy a league pass, predict markets, win the prize pool</div>
      </div>

      {/* My active entries */}
      {myLeagues.filter(e=>e.league_status==='open').map(e => (
        <div key={e.id} style={{ background:'linear-gradient(135deg,rgba(255,107,26,.12),rgba(245,200,66,.08))', border:'1px solid rgba(255,107,26,.3)', borderRadius:16, padding:'16px 20px', marginBottom:20 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
            <div style={{ fontWeight:700, fontSize:15, color:'#ff6b35' }}>{e.display_name} League — Week #{e.week_number}</div>
            <span style={{ fontSize:11, background:'rgba(255,107,26,.15)', color:'#ff6b35', borderRadius:20, padding:'3px 10px', fontWeight:600 }}>ENTERED ✅</span>
          </div>
          <div style={{ display:'flex', gap:20, fontSize:13, color:'var(--text2)', marginBottom:12 }}>
            <span>⭐ {Math.round(e.points||0)} pts</span>
            <span>✅ {e.correct_predictions}/{e.total_predictions} correct</span>
            <span>🎯 {Math.round(e.accuracy||0)}% accuracy</span>
          </div>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <div style={{ fontSize:14, color:'var(--text)' }}>Rank <strong style={{ color:'#f5c842' }}>#{e.live_rank||'?'}</strong> of {e.player_count}</div>
            <button onClick={() => viewBoard(e.league_id, e.tier, e.week_number)}
              style={{ padding:'7px 16px', background:'rgba(255,107,26,.15)', border:'1px solid #ff6b35', borderRadius:8, color:'#ff6b35', fontSize:12, fontWeight:600, cursor:'pointer' }}>
              View Board
            </button>
          </div>
        </div>
      ))}

      {/* Tier cards */}
      <div style={{ display:'grid', gap:16 }}>
        {tiers.map(tier => {
          const active   = leagues.find(l=>l.tier===tier.tier);
          const myEntry  = myLeagues.find(e=>e.tier===tier.tier&&e.league_status==='open');
          const isLocked = !tier.is_active;
          const pool     = active ? Math.floor((active.player_count*active.entry_fee_ngn*0.85)/20) : 0;
          const prize1st = Math.floor(pool*0.5);

          return (
            <div key={tier.tier} className="card" style={{ opacity: isLocked?0.6:1, border:`1px solid ${myEntry?'rgba(0,197,102,.3)':isLocked?'var(--border)':'var(--border)'}` }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:14 }}>
                <div>
                  <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:20, letterSpacing:1, marginBottom:2 }}>{tier.display_name} LEAGUE</div>
                  <div style={{ fontSize:12, color:'var(--text2)' }}>Entry: ₦{(tier.entry_fee_ngn||0).toLocaleString()} · +{tier.bonus_stars} ⭐ bonus</div>
                </div>
                {isLocked
                  ? <span className="tag" style={{ background:'var(--bg3)', color:'var(--muted)' }}>🔒 LOCKED</span>
                  : myEntry
                    ? <span className="tag" style={{ background:'rgba(0,197,102,.1)', color:'#00c566' }}>✅ ENTERED</span>
                    : <span className="tag" style={{ background:'rgba(255,107,53,.1)', color:'#ff6b35' }}>OPEN</span>
                }
              </div>

              {isLocked ? (
                <div>
                  <div style={{ fontSize:12, color:'var(--text2)', marginBottom:8 }}>Unlocks when Bronze averages {tier.unlock_needed}+ players/week</div>
                  <div style={{ height:4, background:'var(--bg3)', borderRadius:4, overflow:'hidden' }}>
                    <div style={{ height:'100%', width:`${tier.unlock_pct||0}%`, background:'linear-gradient(90deg,#ff6b35,#f5c842)', borderRadius:4 }}/>
                  </div>
                  <div style={{ fontSize:11, color:'var(--muted)', marginTop:4 }}>{tier.unlock_progress||0}/{tier.unlock_needed} avg players</div>
                </div>
              ) : (
                <>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10, marginBottom:14 }}>
                    {[
                      { label:'🥇 1st Prize', value:`${prize1st} ⭐`, sub:`₦${((prize1st||0)*15).toLocaleString()}`, color:'#f5c842' },
                      { label:'👥 Players', value:active?active.player_count:0, sub:`Min ${tier.min_players}`, color:'#ff6b35' },
                      { label:'💰 Pool', value:`${pool} ⭐`, sub:'Growing!', color:'#00c566' },
                    ].map(s => (
                      <div key={s.label} style={{ textAlign:'center', background:'var(--bg2)', borderRadius:10, padding:'10px 8px' }}>
                        <div style={{ fontSize:16, fontWeight:700, color:s.color }}>{s.value}</div>
                        <div style={{ fontSize:10, color:'var(--muted)', marginTop:2 }}>{s.label}</div>
                        <div style={{ fontSize:10, color:s.color }}>{s.sub}</div>
                      </div>
                    ))}
                  </div>
                  <div style={{ fontSize:11, color:'var(--muted)', marginBottom:12 }}>⏰ Closes Sunday 23:59 · Odds-based scoring · Top 3 win prizes</div>
                  {myEntry
                    ? <button onClick={() => viewBoard(active?.id, tier.tier, active?.week_number)}
                        style={{ width:'100%', padding:12, background:'rgba(0,197,102,.1)', border:'1px solid #00c566', borderRadius:10, color:'#00c566', fontSize:14, fontWeight:600, cursor:'pointer' }}>
                        📊 View Leaderboard
                      </button>
                    : <button onClick={() => buyPass(tier.tier)} disabled={paying[tier.tier]}
                        className="btn-primary" style={{ width:'100%', padding:12, fontSize:14 }}>
                        {paying[tier.tier] ? 'Opening payment...' : `🏆 Buy ${tier.display_name} Pass — ₦${(tier.entry_fee_ngn||0).toLocaleString()}`}
                      </button>
                  }
                </>
              )}
            </div>
          );
        })}
      </div>

      {/* Leaderboard modal */}
      {board && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.8)', zIndex:500, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}
          onClick={e => e.target===e.currentTarget && setBoard(null)}>
          <div className="card" style={{ width:'100%', maxWidth:500, maxHeight:'80vh', overflow:'hidden', display:'flex', flexDirection:'column' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
              <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:18, letterSpacing:1 }}>
                🏆 {board.tier.toUpperCase()} LEAGUE — WEEK #{board.week}
              </div>
              <button onClick={() => setBoard(null)} style={{ background:'var(--bg3)', border:'none', color:'var(--text2)', borderRadius:'50%', width:28, height:28, fontSize:14 }}>✕</button>
            </div>
            <div style={{ overflowY:'auto', flex:1 }}>
              {board.entries.length === 0
                ? <div style={{ textAlign:'center', padding:40, color:'var(--muted)' }}>No entries yet. Be first to stake!</div>
                : board.entries.map((e,i) => (
                  <div key={e.id} style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 12px', borderRadius:10, marginBottom:6,
                    background: myLeagues.some(m=>m.user_id===e.user_id)?'rgba(255,107,26,.08)':'rgba(255,255,255,.02)',
                    border:`1px solid ${myLeagues.some(m=>m.user_id===e.user_id)?'rgba(255,107,26,.3)':'rgba(255,255,255,.06)'}` }}>
                    <div style={{ fontSize:18, minWidth:30, textAlign:'center' }}>{i===0?'🥇':i===1?'🥈':i===2?'🥉':`#${i+1}`}</div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:13, fontWeight:600 }}>{e.first_name||'User'}</div>
                      <div style={{ fontSize:11, color:'var(--muted)' }}>{e.correct_predictions}/{e.total_predictions} correct · {Math.round(e.accuracy||0)}% accuracy</div>
                    </div>
                    <div style={{ fontSize:14, fontWeight:700, color:'#f5c842' }}>{Math.round(e.points||0)} pts</div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
